<template>
  <component :is="iconComponent" v-if="iconComponent" />
</template>

<script>
/**
 * @deprecated Import SVG icons directly instead:
 *   import MyIcon from "assets/icons/my-icon.svg?vue";
 *   <MyIcon class="..." />
 */
import { getIconComponent } from "./useSvgIcons";

export default {
  name: "UseSvg",
  props: {
    icon: {
      required: true,
      type: String
    },
    type: {
      validator(value) {
        return ["jiffy", "product_collections", "brand_page", "neck_labels"].includes(value);
      },
      default: "jiffy"
    }
  },
  computed: {
    iconComponent() {
      return getIconComponent(this.icon, this.type);
    }
  }
};
</script>
